/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offerdetail_Achievements_Dlc1Inputs */

const id_offerdetail_achievements_dlc1 = /** @type {(inputs: Offerdetail_Achievements_Dlc1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DLC`)
};

const ms_offerdetail_achievements_dlc1 = /** @type {(inputs: Offerdetail_Achievements_Dlc1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DLC`)
};

const da_offerdetail_achievements_dlc1 = /** @type {(inputs: Offerdetail_Achievements_Dlc1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DLC`)
};

const de_offerdetail_achievements_dlc1 = /** @type {(inputs: Offerdetail_Achievements_Dlc1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DLC`)
};

const en_us2_offerdetail_achievements_dlc1 = /** @type {(inputs: Offerdetail_Achievements_Dlc1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DLC`)
};

const es_es2_offerdetail_achievements_dlc1 = /** @type {(inputs: Offerdetail_Achievements_Dlc1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DLC`)
};

const es_mx2_offerdetail_achievements_dlc1 = /** @type {(inputs: Offerdetail_Achievements_Dlc1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DLC`)
};

const fil_offerdetail_achievements_dlc1 = /** @type {(inputs: Offerdetail_Achievements_Dlc1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DLC`)
};

const fr_offerdetail_achievements_dlc1 = /** @type {(inputs: Offerdetail_Achievements_Dlc1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DLC`)
};

const it_offerdetail_achievements_dlc1 = /** @type {(inputs: Offerdetail_Achievements_Dlc1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DLC`)
};

const hu_offerdetail_achievements_dlc1 = /** @type {(inputs: Offerdetail_Achievements_Dlc1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DLC`)
};

const nl_offerdetail_achievements_dlc1 = /** @type {(inputs: Offerdetail_Achievements_Dlc1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DLC`)
};

const no_offerdetail_achievements_dlc1 = /** @type {(inputs: Offerdetail_Achievements_Dlc1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DLC`)
};

const pl_offerdetail_achievements_dlc1 = /** @type {(inputs: Offerdetail_Achievements_Dlc1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DLC`)
};

const pt_br2_offerdetail_achievements_dlc1 = /** @type {(inputs: Offerdetail_Achievements_Dlc1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DLC`)
};

const pt_offerdetail_achievements_dlc1 = /** @type {(inputs: Offerdetail_Achievements_Dlc1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DLC`)
};

const ro_offerdetail_achievements_dlc1 = /** @type {(inputs: Offerdetail_Achievements_Dlc1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DLC`)
};

const fi_offerdetail_achievements_dlc1 = /** @type {(inputs: Offerdetail_Achievements_Dlc1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DLC`)
};

const sv_offerdetail_achievements_dlc1 = /** @type {(inputs: Offerdetail_Achievements_Dlc1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DLC`)
};

const vi_offerdetail_achievements_dlc1 = /** @type {(inputs: Offerdetail_Achievements_Dlc1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DLC`)
};

const tr_offerdetail_achievements_dlc1 = /** @type {(inputs: Offerdetail_Achievements_Dlc1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DLC`)
};

const cs_offerdetail_achievements_dlc1 = /** @type {(inputs: Offerdetail_Achievements_Dlc1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DLC`)
};

const bg_offerdetail_achievements_dlc1 = /** @type {(inputs: Offerdetail_Achievements_Dlc1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DLC`)
};

const ru_offerdetail_achievements_dlc1 = /** @type {(inputs: Offerdetail_Achievements_Dlc1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DLC`)
};

const uk_offerdetail_achievements_dlc1 = /** @type {(inputs: Offerdetail_Achievements_Dlc1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DLC`)
};

const ar_offerdetail_achievements_dlc1 = /** @type {(inputs: Offerdetail_Achievements_Dlc1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DLC`)
};

const hi_offerdetail_achievements_dlc1 = /** @type {(inputs: Offerdetail_Achievements_Dlc1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DLC`)
};

const th_offerdetail_achievements_dlc1 = /** @type {(inputs: Offerdetail_Achievements_Dlc1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DLC`)
};

const ja_offerdetail_achievements_dlc1 = /** @type {(inputs: Offerdetail_Achievements_Dlc1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DLC`)
};

const zh_cn2_offerdetail_achievements_dlc1 = /** @type {(inputs: Offerdetail_Achievements_Dlc1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DLC`)
};

const zh_hant1_offerdetail_achievements_dlc1 = /** @type {(inputs: Offerdetail_Achievements_Dlc1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DLC`)
};

const ko_offerdetail_achievements_dlc1 = /** @type {(inputs: Offerdetail_Achievements_Dlc1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DLC`)
};

/**
* | output |
* | --- |
* | "DLC" |
*
* @param {Offerdetail_Achievements_Dlc1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const offerdetail_achievements_dlc1 = /** @type {((inputs?: Offerdetail_Achievements_Dlc1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offerdetail_Achievements_Dlc1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_offerdetail_achievements_dlc1(inputs)
	if (locale === "ms") return ms_offerdetail_achievements_dlc1(inputs)
	if (locale === "da") return da_offerdetail_achievements_dlc1(inputs)
	if (locale === "de") return de_offerdetail_achievements_dlc1(inputs)
	if (locale === "en-US") return en_us2_offerdetail_achievements_dlc1(inputs)
	if (locale === "es-ES") return es_es2_offerdetail_achievements_dlc1(inputs)
	if (locale === "es-MX") return es_mx2_offerdetail_achievements_dlc1(inputs)
	if (locale === "fil") return fil_offerdetail_achievements_dlc1(inputs)
	if (locale === "fr") return fr_offerdetail_achievements_dlc1(inputs)
	if (locale === "it") return it_offerdetail_achievements_dlc1(inputs)
	if (locale === "hu") return hu_offerdetail_achievements_dlc1(inputs)
	if (locale === "nl") return nl_offerdetail_achievements_dlc1(inputs)
	if (locale === "no") return no_offerdetail_achievements_dlc1(inputs)
	if (locale === "pl") return pl_offerdetail_achievements_dlc1(inputs)
	if (locale === "pt-BR") return pt_br2_offerdetail_achievements_dlc1(inputs)
	if (locale === "pt") return pt_offerdetail_achievements_dlc1(inputs)
	if (locale === "ro") return ro_offerdetail_achievements_dlc1(inputs)
	if (locale === "fi") return fi_offerdetail_achievements_dlc1(inputs)
	if (locale === "sv") return sv_offerdetail_achievements_dlc1(inputs)
	if (locale === "vi") return vi_offerdetail_achievements_dlc1(inputs)
	if (locale === "tr") return tr_offerdetail_achievements_dlc1(inputs)
	if (locale === "cs") return cs_offerdetail_achievements_dlc1(inputs)
	if (locale === "bg") return bg_offerdetail_achievements_dlc1(inputs)
	if (locale === "ru") return ru_offerdetail_achievements_dlc1(inputs)
	if (locale === "uk") return uk_offerdetail_achievements_dlc1(inputs)
	if (locale === "ar") return ar_offerdetail_achievements_dlc1(inputs)
	if (locale === "hi") return hi_offerdetail_achievements_dlc1(inputs)
	if (locale === "th") return th_offerdetail_achievements_dlc1(inputs)
	if (locale === "ja") return ja_offerdetail_achievements_dlc1(inputs)
	if (locale === "zh-CN") return zh_cn2_offerdetail_achievements_dlc1(inputs)
	if (locale === "zh-Hant") return zh_hant1_offerdetail_achievements_dlc1(inputs)
	return ko_offerdetail_achievements_dlc1(inputs)
});
export { offerdetail_achievements_dlc1 as "offerDetail.achievements.dlc" }